import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OauthRedirectLoginGuard } from 'src/guards/oauth-redirect-login.guard';
import { OauthRoute } from 'src/models/routes.model';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: OauthRoute.BCAS_CALLBACK,
        canActivate: [OauthRedirectLoginGuard],
        children: [] // children or component must be provided
      },
    ]),
  ]
})
export class OauthModule { }
